// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Typography } from '@mui/material'
import * as icons from '@tabler/icons'
import TitleService from 'title-service'

import { Views } from 'features/enumerations'

// assets

import { getUserClaims } from 'features/application/application-slice'
import { useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const navigate = useNavigate()
  let claims = useSelector(getUserClaims)
  const customization = useSelector((state: any) => state.customization)

  function viewprofilelistcomponent(comp: any): any {
    return (
      <>
        {claims?.player && (
          <div>
            <List>
              <ListItemButton
                sx={{ borderRadius: `${customization.borderRadius}px` }}
                onClick={() => {
                  navigate(`/${Views.Players}`)
                }}
              >
                <ListItemIcon>
                  <icons.IconUsers stroke={1.5} size="2.3rem" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h3">
                      {TitleService('Players')}
                    </Typography>
                  }
                />
              </ListItemButton>
            </List>
          </div>
        )}
      </>
    )
  }

  let output_viewprofilelistcomponent = viewprofilelistcomponent(null)

  return output_viewprofilelistcomponent
}
